import React from 'react'
import cx from 'classnames'
import { color } from '@manychat/manyui'

import { InfoBannerProps } from './types'

import cm from './InfoBanner.module.css'

export const InfoBanner = ({ icon, title, description, className }: InfoBannerProps) => {
  const Icon = icon

  return (
    <div className={cx(cm.root, className)}>
      <Icon className="flex-shrink-0" size={24} color={color.icon.brand} />
      <div>
        <h3 className={cm.title}>{title}</h3>
        <p className={cm.description}>{description}</p>
      </div>
    </div>
  )
}
